import _ from 'underscore';
import ko from 'knockout';
import { KoSchema } from '@bingads-webui/ko-schema';
import {
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

export default class ViewModel {
  constructor({
    i18n,
    formatSuggestedBid,
    appConfig,
    newI18n,
    recommendationType,
    suggestedBid,
  }) {
    this.i18n = i18n;
    this.formatSuggestedBid = formatSuggestedBid;
    this.appConfig = appConfig;
    this.newI18n = newI18n;
    this.recommendationType = recommendationType;
    this.suggestedBid = suggestedBid;
    this.inputBid = ko.observable('');
    this.userInputDisplayVal = ko.observable(formatSuggestedBid);
    this.userInputDisplayVal.subscribe((value) => {
      this.inputBid(i18n.isValidDecimal(value) ? i18n.parseDecimal(value) : value);
      this.inputBid.validate();
    });
    this.validateUserInput();
  }

  validateUserInput() {
    const { appConfig } = this;
    const minBid = appConfig.get('KeywordBidRange').FloorValue;
    const maxBid = appConfig.get('KeywordBidRange').CeilingValue;
    const {
      i18n, formatSuggestedBid, recommendationType, suggestedBid,
    } = this;
    const schema = {
      properties: {
        inputBid: {
          type: 'number',
          required: true,
          default: formatSuggestedBid,
          minimum: minBid,
          maximum: maxBid,
        },
      },
    };
    KoSchema(this, schema, _.keys(schema.properties), {}, {}, i18n);

    this.inputBid.validators.type.message = i18n.getString('ErrorMessage_InputNumericValue');
    this.inputBid.validators.range.message
      = i18n.getString('NewKeywordSuggestionsValidationMsg')
        .replace('{0}', minBid)
        .replace('{1}', i18n.currency)
        .replace('{2}', maxBid)
        .replace('{3}', i18n.currency);

    this.errorMessage = ko.observable('');
    this.showErrorMessage = ko.computed(() => {
      if (!this.inputBid.isValid()) {
        this.errorMessage(_.first(this.inputBid.errors()));
        return true;
      }
      return false;
    });
    this.warningMessage = ko.observable('');
    this.showWarningMessage = ko.computed(() => {
      const inputBid = Number(this.inputBid());
      if (recommendationType === RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID
        && _.isNumber(inputBid) && _.isNumber(suggestedBid) && _.isNumber(minBid)
        && inputBid < suggestedBid && inputBid >= minBid) {
        this.warningMessage(this.newI18n.getString(_TL_('The bid you set is lower than recommended. Increasing your bid to {0}{1} will earn more impressions and clicks.'))
          .replace('{0}', suggestedBid)
          .replace('{1}', i18n.currency));
        return true;
      }
      return false;
    });
  }
}
